module.exports = __webpack_public_path__ + "static/media/RP_Trinityplace.e8736453.jpg";